var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 179,
    viewBox: "0 0 183 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.581 30.1687L60.5088 118.628C51.6943 133.895 56.8592 153.378 72.0448 162.146C87.2304 170.913 106.686 165.644 115.501 150.377L166.572 61.9183C175.387 46.6513 170.222 27.1675 155.036 18.4001C139.851 9.63268 120.395 14.9017 111.581 30.1687Z",
    fill: "url(#paint0_linear_270_8111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.554 29.8644C162.228 25.8756 156.676 23.4746 150.807 23.0548C140.167 22.6293 126.973 27.7364 118.036 43.4836L66.5385 136.69C64.6671 142.592 65.1239 148.988 67.8153 154.565C70.1567 159.496 74.0413 163.53 78.8809 166.056C70.8769 163.164 64.1135 157.603 59.729 150.309C52.4938 137.115 58.8778 122.645 59.729 120.517L66.5385 108.6L79.7321 86.4689L101.012 49.0163C102.714 45.6115 104.842 42.6324 106.97 39.2276C108.341 35.6277 110.361 32.3099 112.929 29.4388C115.216 26.1145 117.936 23.109 121.015 20.5013C125.022 17.614 129.623 15.6573 134.483 14.7737C139.342 13.8902 144.337 14.1021 149.105 15.3941C156.536 17.8477 162.768 23.0154 166.554 29.8644Z",
    fill: "url(#paint1_linear_270_8111)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9916 28.6402C63.2084 12.8226 44.1616 6.26736 28.4494 13.9987C12.7372 21.7301 6.30956 40.8203 14.0928 56.6379L59.171 148.249C66.9542 164.066 86.001 170.622 101.713 162.89C117.425 155.159 123.853 136.069 116.07 120.251L70.9916 28.6402Z",
    fill: "url(#paint2_linear_270_8111)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.982 10.7127C38.2965 12.2403 33.2347 15.5156 29.5117 20.0759C23.1277 28.5879 20.1485 42.6326 28.2349 58.3797L77.6042 153.288C81.5037 157.974 86.9277 161.138 92.9258 162.226C98.3601 163.012 103.901 161.963 108.673 159.246C101.949 164.307 93.6717 166.866 85.265 166.482C80.1062 165.764 75.1734 163.901 70.8284 161.029C66.4834 158.157 62.8363 154.348 60.1547 149.883L54.1963 137.967L42.7052 114.559L23.1277 75.8292C21.7439 72.3462 20.1813 68.9369 18.4461 65.6149C16.3279 62.2832 14.6135 58.7115 13.3389 54.9749C12.1617 51.2243 11.3074 47.38 10.7853 43.4838C10.5326 39.0775 11.2216 34.668 12.8064 30.5488C14.3912 26.4296 16.8355 22.6954 19.9764 19.5948C23.1173 16.4941 26.8827 14.0983 31.022 12.5668C35.1613 11.0352 39.5793 10.4032 43.982 10.7127Z",
    fill: "url(#paint3_linear_270_8111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, "2\r\n", /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_270_8111",
    x1: 86.0545,
    y1: 74.5513,
    x2: 141.046,
    y2: 106.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEC62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C6C34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A2C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#82BD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#66BB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#50B9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3FB8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#34B7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2DB6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB6C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_270_8111",
    x1: 173.844,
    y1: 38.8547,
    x2: 43.5186,
    y2: 125.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EFC62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DCED9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_270_8111",
    x1: 9.46726,
    y1: 86.5675,
    x2: 121.152,
    y2: 90.2864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85C48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#84C48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#79C295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5CBEA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2CB6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB6C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_270_8111",
    x1: 60.027,
    y1: 10.7127,
    x2: 60.027,
    y2: 166.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EFC62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DCED9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6c3e3bba4d20a8d9457bb515cac6f660.svg";
export { ForwardRef as ReactComponent };